const ENV = process.env.REACT_APP_ENVIRONMENT || 'dev';

const AUTOCOMPLETE_OFF_ENVS = ['prod'];

const SESSION_TIMEOUT = {
  prod: 15 * 60 * 1000,
  uat: 30 * 60 * 1000,
  uat_us: 30 * 60 * 1000,
  staging: 10 * 60 * 1000,
  dev: 60 * 60 * 1000,
};

const securityConfig = {
  autoCompleteOff: AUTOCOMPLETE_OFF_ENVS.includes(ENV),
  sessionTimeoutMs: SESSION_TIMEOUT[ENV] || 60 * 60 * 1000,
};

export default securityConfig;
